import React, { FC, useState } from 'react';
import { Box, Button, Grid, Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FreeTextFilterComponent from 'components/users/shared/free-text-filter/free-text-filter.component';
import { UserListFilter } from 'models/user';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import AddIcon from '@mui/icons-material/Add';

type TechniciansPageActionsProps = {
    onFilterChange: (technicianFilter: UserListFilter) => void;
    onDialogOpenClick: () => void;
};

const TechniciansPageActions: FC<TechniciansPageActionsProps> = ({
    onFilterChange,
    onDialogOpenClick,
}: TechniciansPageActionsProps) => {
    const { t: translate } = useTranslation(['users']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const [technicianFilter, setTechnicianFilter] = useState<UserListFilter>({
        freeText: '',
        active: true,
    });

    const handleFilterChange = (filterValue: string) => {
        setTechnicianFilter({
            freeText: filterValue,
            active: technicianFilter.active,
        });
        onFilterChange({
            freeText: filterValue,
            active: technicianFilter.active,
        });
    };
    const handleStatusSelect = (filterStatus: boolean | null) => {
        setTechnicianFilter({
            freeText: technicianFilter.freeText,
            active: filterStatus,
        });
        onFilterChange({
            freeText: technicianFilter.freeText,
            active: filterStatus,
        });
    };

    return (
        <Box mb={1} display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column-reverse'}>
            <Grid container spacing={1}>
                <Grid item md={4} xs={12}>
                    <FreeTextFilterComponent
                        value={technicianFilter.freeText}
                        freeTextFilterChange={handleFilterChange}
                        label="FILTER_NAME"
                    />
                </Grid>
                <Grid item md={2} xs={12}>
                    <FilterOnStatusDropdown fullWidth statusSelected={handleStatusSelect} />
                </Grid>
            </Grid>
            <Box flex="1 0 auto">
                <Button fullWidth variant="contained" size="medium" onClick={onDialogOpenClick} startIcon={<AddIcon />}>
                    {translate('users:ADD_USER')}
                </Button>
            </Box>
        </Box>
    );
};
export default TechniciansPageActions;
